import { render } from "./WelcomeContact.vue?vue&type=template&id=a86db57c&scoped=true"
import script from "./WelcomeContact.vue?vue&type=script&lang=js"
export * from "./WelcomeContact.vue?vue&type=script&lang=js"

import "./WelcomeContact.vue?vue&type=style&index=0&id=a86db57c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86db57c"]])

export default __exports__